import type { IconData } from '@stacksjs/iconify-core'

export const webGridAlt: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M22 8H2v2h9v12h2V10h9z\" opacity=\".25\"/><path fill=\"currentColor\" d=\"M3 2h18a1 1 0 0 1 1 1v5H2V3a1 1 0 0 1 1-1\"/><path fill=\"currentColor\" d=\"M2 10h9v12H3a1 1 0 0 1-1-1zm11 0h9v11a1 1 0 0 1-1 1h-8z\" opacity=\".5\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default webGridAlt
